module.exports = __webpack_public_path__ + "static/media/stijn-bessem-clients-douwe-egberts.bcdb33dd.svg";